import React, { useEffect, useState } from 'react';
import Styles from './Accordion.css';
import clsx from 'clsx';

function Accordion({ title = '', children, open = false, setOpen, className, id }) {
  const [hideOverflow, setHideOverflow] = useState(!open);

  useEffect(() => {
    if (open && hideOverflow) {
      setHideOverflow(false);
      return;
    }

    if (!hideOverflow && !open) {
      setTimeout(() => {
        setHideOverflow(true);
      }, 100);
      return;
    }
  }, [hideOverflow, open]);

  return (
    <>
      <div
        id={id}
        className={clsx(
          {
            accordion: true,
            open,
          },
          className,
        )}
      >
        <div
          className="acc-head"
          onClick={(ev) => {
            ev.preventDefault();

            if (!setOpen) return;

            setOpen(!open);
          }}
        >
          {!!title && <>{typeof title === 'string' ? <p>{title}</p> : <>{title}</>}</>}
          <img
            alt=""
            src="assets/simulador-energia-solar/jornada/ic-arrow-up.svg"
            className="acc-arrow"
          />
        </div>

        <div className="acc-body">
          <div
            className="acc-body-inner"
            style={{
              overflow: hideOverflow ? 'hidden' : 'visible',
            }}
          >
            {children}
          </div>
        </div>
      </div>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Accordion;
